import { render, staticRenderFns } from "./DemoInstructionPopup.vue?vue&type=template&id=276de5ac&scoped=true&"
import script from "./DemoInstructionPopup.vue?vue&type=script&lang=js&"
export * from "./DemoInstructionPopup.vue?vue&type=script&lang=js&"
import style0 from "./DemoInstructionPopup.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DemoInstructionPopup.vue?vue&type=style&index=1&id=276de5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276de5ac",
  null
  
)

export default component.exports